import { render, staticRenderFns } from "./ready.vue?vue&type=template&id=708cfd9a&scoped=true"
import script from "./ready.vue?vue&type=script&lang=js"
export * from "./ready.vue?vue&type=script&lang=js"
import style0 from "./ready.vue?vue&type=style&index=0&id=708cfd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cfd9a",
  null
  
)

export default component.exports